import yup from './yup'
const { object, array, string, number } = yup

const NAME_REGEX = /^[\p{L}]+(?:[ .'-][\p{L}]+)*$/u

export const addBadgeConfigurationSchema = () =>
  object({
    title: string()
      .label('Badge Configuration Title')
      .trimmedRequired('Badge Configuration Title is required')
      .max(100, 'Badge Configuration Title must not exceed 100 characters'),
    badgeBarColor: string().label('Badge Bar Color').required('Badge Bar Color is required'),
    fieldsAppliedInsideQRCode: array()
      .of(string().required('Each option must be a string'))
      .min(1, 'Please select at least one option to apply inside the QR code')
      .required('Please select at least one option to apply inside the QR code'),
    applicableSubjects: array()
      .of(string().required('Each option must be a string'))
      .min(1, 'Please select at least one option')
      .required('Please select at least one option'),
    badgeLayout: array().of(array().of(string())).optional(),
    badgeNameFormat: string().optional(),
    badgeLineFontSizes: array().of(number()).optional(),
    badgeOrientation: string().optional()
  })

export const addBadgeSubjectSchema = () =>
  object({
    counter: number().min(1).label('Counter').required('Counter is required'),
    firstName: string()
      .label('First Name')
      .trimmedRequired('First Name is required')
      .max(50, 'First Name must not exceed 50 characters')
      .matches(NAME_REGEX, 'First Name must not contain numbers or special characters'),
    lastName: string()
      .label('Last Name')
      .trimmedRequired('Last Name is required')
      .max(50, 'Last Name must not exceed 50 characters')
      .matches(NAME_REGEX, 'Last Name must not contain numbers or special characters'),
    credential: string().label('Credential'),
    email: string()
      .label('Email')
      .email('Please enter a valid email address')
      .required('Email is required'),
    type: string().label('Type').required('Subject Type is required'),
    position: string().label('Position/Title'),
    organization: string().label('Organization'),
    country: string().label('Country'),
    state: string().label('State'),
    city: string().label('City'),
    phone: string().label('Phone')
  })

export const pdfConfigurationSchema = () =>
  object({
    pageSize: string().label('Page Size').required(),
    orientation: string().label('First Name').required()
  })
